import { fetchMethods } from '../types/FetchService.types';

import { createHttpHeader } from '@/utils/network/createHTTPHeaders';
import { decryptTreezorResponse } from '@/services/encryption/decryptTreezorResponse';
import { ITemplateDesign, ITemplateModel } from '@/store/models/template.model';
import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';
import { fetchQuery } from '@/utils/queryClient';
export class TemplateService {
  static queryKey = 'Template';
  static searchTemplates = async (): Promise<string[]> => {
    try {
      const config = getStaticDashboardConfig();
      const url = `${config.api.baseUrl}/customization/templates`;

      const templatesResponse = await fetchQuery([this.queryKey, { method: fetchMethods.GET }], url, {
        headers: createHttpHeader(),
      });

      return await decryptTreezorResponse(templatesResponse, { shouldSkipEncryption: true });
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static searchTemplateModel = async (template: string): Promise<ITemplateModel | undefined> => {
    try {
      const config = getStaticDashboardConfig();

      const templateModelResponse = await fetchQuery(
        [this.queryKey, { method: fetchMethods.GET, id: template, params: { type: 'model' } }],
        `${config.api.baseUrl}/customization/templates/${template}`,
        {
          headers: createHttpHeader(),
        },
      );

      return await decryptTreezorResponse<ITemplateModel | undefined>(templateModelResponse, {
        shouldSkipEncryption: true,
        isSingle: true,
      });
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static searchTemplateDesign = async (template: string): Promise<ITemplateDesign | undefined> => {
    try {
      const config = getStaticDashboardConfig();

      const templateDesignResponse = await fetchQuery(
        [this.queryKey, { method: fetchMethods.GET, id: template, params: { type: 'design' } }],
        `${config.api.baseUrl}/customization/templates/${template}/template`,
        {
          headers: createHttpHeader(),
        },
      );

      return await decryptTreezorResponse<ITemplateDesign | undefined>(templateDesignResponse, {
        shouldSkipEncryption: true,
        isSingle: true,
      });
    } catch (err) {
      return Promise.reject(err);
    }
  };
  static saveTemplate = async (template: ITemplateDesign, templateName: string): Promise<void> => {
    try {
      const config = getStaticDashboardConfig();
      await fetchQuery(
        [this.queryKey, { method: fetchMethods.PUT, id: templateName, params: { type: 'model', template } }],
        `${config.api.baseUrl}/customization/templates/${templateName}/template`,
        {
          headers: createHttpHeader(),
          body: JSON.stringify(template),
        },
      );
    } catch (err) {
      return Promise.reject(err);
    }
  };
}
